import hfbs from "../components/InputPopup/UserFiltersRow/hfbNumbers.json";
import { AREA_OPTIONS } from "../components/RoomSettings/types/media";

export const getDepartmentsOptions = (
  t: (key: string, options?: any) => string
) => [
  ...AREA_OPTIONS.map((area) => ({
    value: area.value,
    name: t(area.translationKey),
  })),
  ...hfbs.map((hfbCode: string) => ({
    value: `HFB ${hfbCode}`,
    name: `HFB${hfbCode} - ${t(`hfb${hfbCode}String`)}`,
  })),
];
